export function calcularCO2(kwh) {
  return kwh * 0.0385;
}

export function calcularArvoresEquivalentes(kwh) {
  return (kwh * 0.0385) / 60;
}